// router.js
import { createRouter, createWebHistory } from 'vue-router';

import Dashboard from './pages/Dashboard.vue';
import Dashboard1 from './pages/Dashboard1.vue';
import Bookings from './pages/Bookings.vue';
import Invoices from './pages/Invoices.vue';
import MyWebsites from './pages/MyWebsites.vue';
import Analytics from './pages/Analytics.vue';
import Aiassitant from './pages/Aiassitant.vue';
import Settings from './pages/Settings.vue';
import AddWebPlan from './pages/AddWebPlan.vue';
import MyNotiList from './pages/MyNotiList.vue';
import BookingPublicPage from './pages/BookingPublicPage.vue';
import BookingPublicPage1 from './pages/BookingPublicPage1.vue';
import AppointmentReport from './pages/AppointmentReport.vue';
// PoPrint
import InvoicePrint from './pages/InvoicePrint.vue';
// InvoicePrint,EstPrint,CmPrint,PoPrint
import AdminSettings from './pages/AdminSettings.vue';
import Plans from './pages/Plans.vue';
import LoginPage from './pages/LoginPage.vue';
import BookingPages from './pages/BookingPages.vue';
import RoutingForm from './pages/RoutingForm.vue';
import PackageList from './pages/PackageList.vue';
import ClientList from './pages/ClientList.vue';
import ItemList from './pages/ItemList.vue';
import ExpList from './pages/ExpList.vue';
import AddBookPage from './pages/AddBookPage.vue';
import NewForm from './pages/NewForm.vue';
import AddPackage from './pages/AddPackage.vue';
import AddInvoice from './pages/AddInvoice.vue';
import ViewInvoice from './pages/ViewInvoice.vue';
import NewClient from './pages/NewClient.vue';
import NewItem from './pages/NewItem.vue';
import NewExp from './pages/NewExp.vue';
import AddNewWebsite from './pages/AddNewWebsite.vue';
import AddEstimate from './pages/AddEstimate.vue';
import AddPuro from './pages/AddPuro.vue';
import AddCreditmemo from './pages/AddCreditmemo.vue';
import PaymentsPage from './pages/PaymentsPage.vue';
import MyLeads from './pages/MyLeads.vue';
import SupportBot from './pages/SupportBot.vue';
import PriceTable from './pages/PriceTable.vue';
import PriceTableAdmin from './pages/PriceTableAdmin.vue';
import MyTeam from './pages/MyTeam.vue';

import HelpPage from './pages/HelpPage.vue';
import MyUsers from './pages/MyUsers.vue';
import UserDetails from './pages/UserDetails.vue';
import WebsiteEditor from './pages/WebsiteEditor.vue';
import NewSingleWeb from './pages/NewSingleWeb.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Dashboard
  },
  {
    path: '/home',
    name: 'Home2',
    component: Dashboard
  },
   {
    path: '/home1',
    name: 'Home1',
    component: Dashboard1
  },
   {
    path: '/my_team',
    name: 'MyTeam',
    component: MyTeam
  },
  {
    path: '/user_details',
    name: 'UserDetails',
    component: UserDetails
  },
   {
    path: '/my_pages',
    name: 'MyWebsites',
    component: MyWebsites
  },
  {
    path: '/web_editor/:web_id',
    name: 'WebsiteEditor',
    component: WebsiteEditor
  },
  {
    path: '/users',
    name: 'MyUsers',
    component: MyUsers
  },
    {
    path: '/leads',
    name: 'MyLeads',
    component: MyLeads
  },
    {
    path: '/support_bot',
    name: 'SupportBot',
    component: SupportBot
  },
   {
    path: '/add_web_plan',
    name: 'AddWebPlan',
    component: AddWebPlan
  },
  
    {
    path: '/pricing_tables',
    name: 'PriceTable',
    component: PriceTable
  },
   {
    path: '/admin_plans',
    name: 'PriceTableAdmin',
    component: PriceTableAdmin
  },
  
  {
    path: '/new_client',
    name: 'NewClient',
    component: NewClient
  },
   
  {
    path: '/new_single_web/:user_id',
    name: 'NewSingleWeb',
    component: NewSingleWeb
  },
  {
    path: '/appointment/:booking_page_id',
    name: 'BookingPublicPage',
    component: BookingPublicPage
  },
  {
    path: '/appointment/embed/:booking_page_id',
    name: 'BookingPublicPage1',
    component: BookingPublicPage1
  },
  {
    path: '/bookreport/:booking_page_id',
    name: 'AppointmentReport',
    component: AppointmentReport
  },
   {
    path: '/payments',
    name: 'PaymentsPage',
    component: PaymentsPage
  },
  {
  path: "/invoice/:mainType/:invoiceId",
  name: "InvoicePrint",
  component: InvoicePrint
}
,
   {
    path: '/new_website',
    name: 'AddNewWebsite',
    component: AddNewWebsite
  },
  {
    path: '/help',
    name: 'HelpPage',
    component: HelpPage
  },
  {
    path: '/new_item',
    name: 'NewItem',
    component: NewItem
  },
  {
    path: '/add_expanse',
    name: 'NewExp',
    component: NewExp
  },
   {
    path: '/add_booking_page',
    name: 'AddBookPage',
    component: AddBookPage
  }
  ,{
    path: '/add_invoice',
    name: 'AddInvoice',
    component: AddInvoice
  }
   ,{
    path: '/add_estimate',
    name: 'AddEstimate',
    component: AddEstimate
  }
   ,{
    path: '/add_purchase_order',
    name: 'AddPuro',
    component: AddPuro
  }
   ,{
    path: '/add_credit_memo',
    name: 'AddCreditmemo',
    component: AddCreditmemo
  }
   ,{
    path: '/view_invoice',
    name: 'ViewInvoice',
    component: ViewInvoice
  }
  ,
   {
    path: '/new_package',
    name: 'AddPackage',
    component: AddPackage
  }
  ,
  {
    path: '/new_form',
    name: 'NewForm',
    component: NewForm
  }
  ,
   {
    path: '/booking_pages',
    name: 'BookingPages',
    component: BookingPages
  }
   ,
   {
    path: '/clients',
    name: 'ClientList',
    component: ClientList
  }
   ,
   {
    path: '/items',
    name: 'ItemList',
    component: ItemList
  }
   ,
   {
    path: '/expanses',
    name: 'ExpList',
    component: ExpList
  }
  ,
   {
    path: '/packages_list',
    name: 'PackageList',
    component: PackageList
  }
  ,
   {
    path: '/routing_form',
    name: 'RoutingForm',
    component: RoutingForm
  }
  ,
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
   {
    path: '/bookings',
    name: 'MyBookings',
    component: Bookings
  },
   {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices
  },
   {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },
  {
    path: '/plans',
    name: 'Plans',
    component: Plans
  },
   {
    path: '/assistant',
    name: 'Aiassitant',
    component: Aiassitant
  },
   {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/notifications',
    name: 'MyNotiList',
    component: MyNotiList
  },
   {
    path: '/admin_settings',
    name: 'AdminSettings',
    component: AdminSettings
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const ldataRaw = sessionStorage.getItem('ldata');
  // http://localhost:5173/login?user_id=2&rtype=settings&type=success&msg=Google%20Calendar%20connected
  const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
  const segments = window.location.pathname.split("/").filter(seg => seg !== "")+"";
  if (
    to.path.includes("appointment") ||
    to.path.includes("web_editor") ||
    to.path.includes("new_single_web") ||
    (segments && segments.localeCompare("invoices")!=0 && to.path.includes("invoice"))
  ) {
    return next();
  }


  if (!to.path.includes("login") && !ldata) {
    return next("/login");
  }

  if (to.path.includes("login") && ldata) {
     alert("1");
    if (ldata.type === "admin") return next("/home1");
    return next("/");
  }

  if (to.path === "/home" && ldata && ldata.type === "admin") {
    return next("/home1");
  }

  if (to.path === "/" && ldata && ldata.type === "admin") {
    return next("/home1");
  }

  if (to.path === "/home1" && ldata && ldata.type === "user") {
    return next("/home");
  }

  next();
});



export default router;
